export default __webpack_public_path__ + "static/media/J_Forms.90216629.png";